import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckIcon, ShareIcon } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function Success() {
  const navigate = useNavigate();
  return <div className="w-full h-full bg-black flex flex-col items-center justify-center px-6 relative overflow-hidden" data-id="element-752">
      {/* Confetti / Background effect */}
      <motion.div initial={{
      scale: 0
    }} animate={{
      scale: 1
    }} transition={{
      duration: 0.5,
      type: 'spring'
    }} className="absolute w-96 h-96 bg-primary/20 rounded-full blur-3xl" data-id="element-753" />

      <motion.div initial={{
      scale: 0,
      rotate: -45
    }} animate={{
      scale: 1,
      rotate: 0
    }} transition={{
      type: 'spring',
      bounce: 0.5,
      delay: 0.2
    }} className="w-32 h-32 bg-primary rounded-full flex items-center justify-center mb-8 z-10 shadow-[0_0_50px_rgba(255,212,0,0.5)]" data-id="element-754">
        <CheckIcon size={64} className="text-black" strokeWidth={3} data-id="element-755" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.4
    }} className="text-center z-10 mb-12" data-id="element-756">
        <h1 className="text-3xl font-poppins font-bold text-white mb-3" data-id="element-757">
          Your video is live!
        </h1>
        <p className="text-softGray" data-id="element-758">Time to make the world laugh.</p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.6
    }} className="w-full flex flex-col gap-4 z-10" data-id="element-759">
        <Button className="flex items-center justify-center gap-2" onClick={() => navigate('/feed')} data-id="element-760">
          <ShareIcon size={20} data-id="element-761" />
          Share Video
        </Button>
        <Button variant="secondary" onClick={() => navigate('/profile')} data-id="element-762">
          View Profile
        </Button>
      </motion.div>
    </div>;
}